import { useField } from '@unform/core';
import React, {
  InputHTMLAttributes,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';

import { Container, Track } from './styles';

interface ISwitchProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
}

const Switch: React.FC<ISwitchProps> = ({ name, ...rest }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const [isChecked, setIsChecked] = useState(false);

  const { defaultValue, fieldName, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'checked',
    });
    setIsChecked(!!inputRef.current?.checked);
  }, [fieldName, registerField]);

  const handleClick = useCallback(() => {
    if (inputRef.current) {
      inputRef.current.checked = !inputRef.current.checked;
      setIsChecked(!!inputRef.current.checked);
    }
  }, []);

  return (
    <Container onClick={handleClick}>
      <Track
        ref={inputRef}
        isChecked={isChecked}
        defaultChecked={!!defaultValue}
        onClick={handleClick}
        type="checkbox"
        {...rest}
      />
    </Container>
  );
};

export { Switch };
